import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tiket",
  "use": "icon-tiket-usage",
  "viewBox": "0 0 1000 1000",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1000 1000\" id=\"icon-tiket\"><path id=\"icon-tiket_SVGID_1_\" d=\"M300,566.7h400v66.7H300V566.7z M300,366.7h400v66.7H300V366.7z M933.3,670.8\n\t\t\tC865,644.2,816.7,577.7,816.7,500S865,355.8,933.3,329.2V166.7H66.7v162.5C135,355.8,183.3,422.3,183.3,500S135,644.2,66.7,670.8\n\t\t\tv162.5h866.7V670.8z M1000,316.7v66.7c-64.4,0-116.7,52.2-116.7,116.7s52.2,116.7,116.7,116.7v66.7V900H0V683.3v-66.7\n\t\t\tc64.4,0,116.7-52.2,116.7-116.7S64.4,383.3,0,383.3v-66.7V100h1000V316.7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/tiket.svg
// module id = G3Cc
// module chunks = 28